import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=ce0a24fa&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce0a24fa')) {
      api.createRecord('ce0a24fa', component.options)
    } else {
      api.reload('ce0a24fa', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=ce0a24fa&", function () {
      api.rerender('ce0a24fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2faaTuQKO2l2D/JS/pricehelp.vue"
export default component.exports